import { render, staticRenderFns } from "./NavbarModern.vue?vue&type=template&id=636efd6f&scoped=true"
import script from "./NavbarModern.vue?vue&type=script&lang=js"
export * from "./NavbarModern.vue?vue&type=script&lang=js"
import style0 from "./NavbarModern.vue?vue&type=style&index=0&id=636efd6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636efd6f",
  null
  
)

export default component.exports